import $ from 'jquery'

// Open
$('.header .hamburger').on('click', function (e) {
  $('.header-overlay').addClass('header-overlay--active')
  $('.header-menu').addClass('header-menu--active')
})

// Close
$('.header-menu-mobile-close button').on('click', function () {
  $('.header-overlay').removeClass('header-overlay--active')
  $('.header-menu').removeClass('header-menu--active')
})

$('.header-menu').on('click', function (e) {
  const activeCls = 'header-menu--active'

  if ($(this).hasClass(activeCls) && e.clientX > 320) {
    $(this).removeClass(activeCls)
  }
})

// Toggle sub menus
$('.header-menu-link--has-sub').on('click', function (e) {
  const href= $(this).attr('href')

  if (href !== '/collections/bundles' && href !== '/collections/all-items') {
    e.preventDefault()
    $(this).next().slideToggle()
  }
})

$('.header-menu-link--has-sub svg').on('click', function (e) {
  e.preventDefault()
  e.stopPropagation()
  $(this).parent().next().slideToggle()
})
